import React from 'react';
import { COLORS } from "Constants/BIDashboardConstants.js"

const PinIcon = () => {
  return (
    <svg id="pin" width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.3134 8.69584L12.931 5H14.25C14.6642 5 15 4.66422 15 4.25V2.75C15 2.33578 14.6642 2 14.25 2H5.75C5.33578 2 5 2.33578 5 2.75V4.25C5 4.66422 5.33578 5 5.75 5H7.06897L6.68663 8.69584C5.17078 9.40062 4 10.6644 4 12.25C4 12.6642 4.33578 13 4.75 13H9V16.2502C9 16.289 9.00903 16.3273 9.02641 16.362L9.77641 17.862C9.86831 18.0458 10.1315 18.0462 10.2236 17.862L10.9736 16.362C10.991 16.3273 11 16.289 11 16.2502V13H15.25C15.6643 13 16 12.6642 16 12.25C16 10.6505 14.8131 9.39313 13.3134 8.69584Z"
        fill={COLORS.oneGp.globalBlue}
      />
    </svg>
  );
};

export default PinIcon;
